import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Database = createReactComponent("Database", ["svg", defaultAttributes, [["ellipse", {
  cx: "12",
  cy: "5",
  rx: "9",
  ry: "3",
  key: "oewo14"
}], ["path", {
  d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3",
  key: "1wf6s5"
}], ["path", {
  d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5",
  key: "1klpzq"
}]]]);
export default Database;